<template>
  
  
      <q-tabs
          v-model="activeTab"
          dense
          class="nav-tabs"
          active-color="primary"
          indicator-color="primary"
          align="left"
          narrow-indicator
      >
        <q-tab name="actions" :label="$t('task.buttons.actions')" class="nav nav-item flex-grow-0" />
        <q-tab name="message" :label="$t('demand.tabs.message')" class="nav nav-item flex-grow-0"/>
        <q-tab name="documentsHistory" :label="$t('demand.tabs.documentsHistory')" class="nav nav-item flex-grow-0"/>
      </q-tabs>
   

   
      <q-tab-panels v-model="activeTab" animated>
        <q-tab-panel name="actions" class="p-0 pt-1">
          
            <OrderHistory
                :isVariables="false"
                :entity-state="entityState"
                :histories-step="historiesStep"
            /> 

        </q-tab-panel>
        <q-tab-panel name="message" class="p-3 pt-1">
          <SummaryMessage :entity-state="entityState" />
        </q-tab-panel>

        <q-tab-panel name="documentsHistory" class="p-3 pt-1">
          <OrderSummaryDocuments  />
        </q-tab-panel>
      </q-tab-panels>
    
  
</template>

<script lang="ts">
import { ref } from 'vue';
import {Options, Vue } from 'vue-class-component';

import SummaryMessage from "@/components/summary-panel/SummaryMessage.vue";

import { useRoute } from 'vue-router';
import OrderHistory from '@/components/order/history/OrderHistory.vue';
import OrderSummaryDocuments from './OrderSummaryDocuments.vue';
@Options({
  components: { SummaryMessage,OrderHistory, OrderSummaryDocuments},
  props: ["entityState", "historiesStep"],
})

export default class OrderSummaryHistory extends Vue {
  activeTab = ref('actions');
  entityState?: any;
  historiesStep?: any;

  isMo() {
    return this.currentRoute !== 'TaskDetail';

  }
  get currentRoute() {
    return useRoute().name;
  }
}
</script>

